import React from 'react'
import './portfolio.css'
import Pimg from '../../assets/portfolio_img.png'
import Pimg2 from '../../assets/portfolio_img02.png'
import Pimg3 from '../../assets/portfolio_img03.png'
import Pimg4 from '../../assets/portfolio_img04.png'
import Pimg5 from '../../assets/portfolio_img05.png'
import Pimg6 from '../../assets/portfolio_img06.png'
const portfolio = () => {
  return (
<section id="portfolio">
      <h5>My Recent Contributions</h5>
      <h2>Portfolio</h2>
      <div className="container portfolio_container">
        <artcile className="portfolio_item">
          <div className="portfolio_item_img">
            <img src={Pimg} alt="" />
          </div>
          <h3>Adam Zain Portfolio Website</h3>
          <div className="item-cta">
          <a href="www.github.com" className='btn'>Github</a>
          <a href="https://dribbble.com/shots/16077352-Personal-Portfolio-Site-Bruno-Erdison" className=' btn btn-primary'>Live Demo</a>
          </div>
        </artcile>
        <artcile className="portfolio_item">
          <div className="portfolio_item_img">
            <img src={Pimg2} alt="" />
          </div>
          <h3>Ukrainian NFT Web-Page</h3>
          <div className="item-cta">
          <a href="www.github.com" className='btn'>Github</a>
          <a href="https://dribbble.com/shots/16077352-Personal-Portfolio-Site-Bruno-Erdison" className=' btn btn-primary'>Live Demo</a>
          </div>
        </artcile>
        <artcile className="portfolio_item">
          <div className="portfolio_item_img">
            <img src={Pimg3} alt="" />
          </div>
          <h3>Shoes Collection by Zain Hanna</h3>
          <div className="item-cta">
          <a href="www.github.com" className='btn'>Github</a>
          <a href="https://dribbble.com/shots/16077352-Personal-Portfolio-Site-Bruno-Erdison" className=' btn btn-primary'>Live Demo</a>
          </div>
        </artcile>
        <artcile className="portfolio_item">
          <div className="portfolio_item_img">
            <img src={Pimg4} alt="" />
          </div>
          <h3>Auto Tax Filling Web-page</h3>
          <div className="item-cta">
          <a href="www.github.com" className='btn'>Github</a>
          <a href="https://dribbble.com/shots/16077352-Personal-Portfolio-Site-Bruno-Erdison" className=' btn btn-primary'>Live Demo</a>
          </div>
        </artcile>
        <artcile className="portfolio_item">
          <div className="portfolio_item_img">
            <img src={Pimg5} alt="" />
          </div>
          <h3>Customer Communication Website</h3>
          <div className="item-cta">
          <a href="www.github.com" className='btn'>Github</a>
          <a href="https://dribbble.com/shots/16077352-Personal-Portfolio-Site-Bruno-Erdison" className=' btn btn-primary'>Live Demo</a>
          </div>
        </artcile>
        <artcile className="portfolio_item">
          <div className="portfolio_item_img">
            <img src={Pimg6} alt="" />
          </div>
          <h3>E-Learning platform</h3>
          <div className="item-cta">
          <a href="www.github.com" className='btn'>Github</a>
          <a href="https://dribbble.com/shots/16077352-Personal-Portfolio-Site-Bruno-Erdison" className=' btn btn-primary'>Live Demo</a>
          </div>
        </artcile>
      </div>
      </section>
  )
}

export default portfolio